// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/types';

export const getSupportCasesWithUnreadMessages = (state: ReduxStateShared): Set<number> =>
  state.messages.supportCasesWithUnreadMessages instanceof Set
    ? state.messages.supportCasesWithUnreadMessages
    : new Set<number>();
